<template>
  <!--  预览表格  广告位竞价专用-->
  <div>
    <!--        输入框-->
    <div>
      基础竞价：
      <gj-input
          v-model="basicPrice"
          width="120px"
          :clearable="false"
          v-number.positive
      >
        <template #append>
          %
        </template>
      </gj-input>
    </div>

    <!--  表格-->
    <gj-table
        :index="false"
        :data="tableData"
        :columns="columns"
        :adapt-height="false"
        :height="500"
        style="margin: 12px 0;"
    >

      <template v-slot:frequency="{ row }">
        每{{ row.dayName }} {{ row.startTime }}-{{ row.endTime }}
      </template>

      <template v-slot:header:price>
        竞价
      </template>

      <template v-slot:price="{ row }">
        <template v-if="row.adjustType === 0">
          预算提高（%）：{{ row.adjustPercent }}%
          <template v-if="row.limit">，最多调整 {{ row.limit }}%</template>
        </template>
        <template v-if="row.adjustType === 1">
          预算降低（%）：{{ row.adjustPercent }}%
          <template v-if="row.limit">，最低调整到 {{ row.limit }}%</template>
        </template>
        <template v-if="row.adjustType === 2">
          预算提高（数值）：{{ row.adjustValue }}%
        </template>
        <template v-if="row.adjustType === 3">
          预算降低（数值）：{{ row.adjustValue }}%
        </template>
        <template v-if="row.adjustType === 4">
          预算直接设置为：{{ row.adjustValue }}%
        </template>

      </template>

      <template v-slot:header:results>
        生效后竞价
        <gj-help>
          预期结果仅提供参考，不作为最终的执行结果；<br>
          预算或竞价降低时，按规则计算的调整值，低于亚马逊最低的预算或竞价，将调整为亚马逊限制的最低价。
        </gj-help>
      </template>

      <template v-slot:results="{ row }">

        <!--        提高（%）-->
        <template v-if="row.adjustType === 0">

          {{ row.finalNum-0 }}%

          <gj-help>
            <template #icon>
              <i class="el-icon-arrow-down"></i>
            </template>
            按规则计算结果：<br>
            <!--          计算值大于限制值-->
            <template v-if="row.limit && row.num - row.limit > 0">
              {{ basicPrice }}% * {{ row.adjustPercent }}% = {{ row.num-0 }}%，大于最多调整的值{{ row.limit }}%，<br>
              所以最终调整为： {{ row.finalNum-0 }}%（ {{ basicPrice }}% + {{ row.limit }}% ）
            </template>
            <!--          计算值不大于限制值-->
            <template v-else>
              {{ basicPrice }}% * {{ row.adjustPercent }}% = {{ row.num-0 }}%，<br>
              所以最终调整为： {{ row.finalNum-0 }}%
            </template>
          </gj-help>

        </template>

        <!--        降低（%）-->
        <template v-if="row.adjustType === 1">

          {{ row.finalNum-0 }}%

          <gj-help>
            <template #icon>
              <i class="el-icon-arrow-down"></i>
            </template>
            按规则计算结果：<br>

<!--            有限制值时-->
            <template v-if="row.limit">
              <!--          计算值大于限制值-->
              <template v-if="row.num > row.limit">
                {{ basicPrice }}% * ( 1-{{ row.adjustPercent }}% ) = {{ row.num-0 }}%，大于等于最低调整到的值{{ row.limit }}%，<br>
                所以最终调整为： {{ row.finalNum-0 }}%
              </template>
              <!--          计算值不大于限制值-->
              <template v-else>
                {{ basicPrice }}% * ( 1-{{ row.adjustPercent }}% ) = {{ row.num-0 }}%，小于最低调整到的值{{ row.limit }}%，<br>
                所以最终调整为： {{ row.finalNum-0 }}%
              </template>

            </template>
<!--            没有有限制值时-->
            <template v-else>
              {{ basicPrice }}% * ( 1-{{ row.adjustPercent }}% ) = {{ row.num-0 }}%，<br>
              所以最终调整为： {{ row.finalNum-0 }}%
            </template>

          </gj-help>

        </template>

        <!--        提高（数值）-->
        <template v-if="row.adjustType === 2">
          {{ row.finalNum }}%
          <gj-help>
            <template #icon>
              <i class="el-icon-arrow-down"></i>
            </template>
            按规则计算结果：<br>
            {{ basicPrice }}% + {{ row.adjustValue }}% = {{ row.finalNum }}%，<br>
            所以最终调整为：{{ row.finalNum }}%
          </gj-help>
        </template>

        <!--        降低（数值）-->
        <template v-if="row.adjustType === 3">
          {{ row.finalNum }}%
          <gj-help>
            <template #icon>
              <i class="el-icon-arrow-down"></i>
            </template>
            按规则计算结果：<br>
            {{ basicPrice }}% - {{ row.adjustValue }}% = {{ row.finalNum }}%，<br>
            所以最终调整为：{{ row.finalNum }}%
          </gj-help>
        </template>

        <!--        直接设置为-->
        <template v-if="row.adjustType === 4">
          {{ row.adjustValue }}%
          <gj-help>
            <template #icon>
              <i class="el-icon-arrow-down"></i>
            </template>
            直接设置为：{{ row.adjustValue }}%
          </gj-help>
        </template>

      </template>

    </gj-table>
  </div>
</template>

<script>
export default {
  name: "ad-preview-placement-table",
  props: {
    data: {
      type: Array
    },
  },
  watch: {
    basicPrice: {
      handler(n,o) {
        this.tableData.forEach(r => {
          // 提高（%）
          if (r.adjustType === 0) {
            this.$set(r, 'num', (n * (r.adjustPercent / 100)).toFixed(2))
            if (r.limit && r.num - r.limit > 0) {
              this.$set(r, 'finalNum', Number(n) + Number(r.limit))
            } else {
              this.$set(r, 'finalNum', (Number(n) + n * (r.adjustPercent / 100)).toFixed(2))
            }
          }
          // 降低（%）
          else if (r.adjustType === 1) {
            this.$set(r, 'num', (n * (1 - (r.adjustPercent / 100))).toFixed(2))
            if (r.limit) {
              if( r.num - r.limit >= 0){
                this.$set(r, 'finalNum', (n * (1 - (r.adjustPercent / 100))).toFixed(2))
              } else {
                this.$set(r, 'finalNum', r.limit)
              }
            }else {
              this.$set(r, 'finalNum', r.num)
            }
          }
          // 提高（数值）
          else if (r.adjustType === 2){
            this.$set(r, 'finalNum', Number(n) + Number(r.adjustValue))
          }
          // 降低（数值）
          else if (r.adjustType === 3){
            this.$set(r, 'finalNum', Number(n) - Number(r.adjustValue))
          }
        })
      },
      immediate: true
    }
  },
  data() {
    return {
      basicPrice: 100,
      tableData: this._.cloneDeep(this.data),
      // 表格配置
      columns: [
        {id: 'frequency', header: '频率（站点时间）', field: 'slot:frequency', width: '180px'},
        {id: 'price', header: 'slot:price', field: 'slot:price', minWidth: '300px'},
        {id: 'results', header: 'slot:results', field: 'slot:results', width: '160px'},
      ]
    }
  }
}
</script>

<style scoped>

</style>